var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"time-picker"},[_c('span',{staticClass:"time-picker__icon"},[_c('DSIcon',{attrs:{"icon":"clock"}})],1),_c('MaskedInput',{staticClass:"time-picker__input",attrs:{"value":_vm.modelValue,"mask":'0`0`:0`0`',"lazy":false,"overwrite":true},on:{"change":_vm.handleModelValueChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }